import React, { useState } from "react";
import { Field, Button, Dropdown, Option } from "@fluentui/react-components";
import { useTaskPane } from "../../provider/TaskPaneProvider";
import services from "../../services/indexService";
import useToast from "../../hooks/useToast";
import AlertPopup from "./AlertPopup";
import { appInsights } from "../../../telemetry/telemetryService";

const SearchCriteria = ({ updateState, clearToaster }) => {
  const appVersion = process.env.AppVersion; 
  const {
    locationData,
    taskPaneState,
    filterTypeByCriteriaType,
    setPoliciesDetailsForInsured,
    setTaskPaneState,
    setSelectedGridItem,
    getLocationSpecificInfo
  } = useTaskPane();
  const { Toaster, notify } = useToast();
  const [open, setOpen] = useState(false);
const handleSearch = async () => {
    try {
      clearToaster();
      const result = await services.searchByCriteria(
        taskPaneState?.compId,
        taskPaneState?.comLocId,
        taskPaneState?.criteria,
        taskPaneState?.searchText,
        taskPaneState.userId
      );
      notify("success", "fetch successful!");
      if (filterTypeByCriteriaType === "Type Insured/Policy") {
        const policyList = result.srchPolicyDeatilsResult?.map(x=> {
          return {
            ...x,
            policyID: x.sub
          }
        })
        setSelectedGridItem(result?.policyId?new Set([result.policyId])  : policyList?.length? new Set([policyList[0]?.policyID?? 0]) : []);
        setPoliciesDetailsForInsured(policyList);
        const insuredResult = result?.srchInsuredByPolicyNumberResult?.length
            ? result?.srchInsuredByPolicyNumberResult
            : result.srchInsuredByNameResult;
        setTaskPaneState((prev) => ({
          ...prev,
          insuredForRecentPoliciesResults: insuredResult,
          insuredId: result?.insuredId? result?.insuredId : insuredResult?.length? insuredResult[0]?.insuredID : "",
          isSearch: true,
        }));
        if(!insuredResult?.length && !result?.srchPolicyDeatilsResult?.length) {
          setOpen(true);
          setTaskPaneState((prev) => ({
          ...prev,
          isSearch: false,
        }));
        }
      } else if (filterTypeByCriteriaType === "Type Producer") {
        const policyList = result.srchProducerResult?.map(x=> {
          return {
            ...x,
            policyID: x.producerId
          }
        })
        setSelectedGridItem(!!result?.producerId? new Set([result.producerId]) : policyList?.length? new Set([policyList[0]?.policyID?? 0]) : []);
        setPoliciesDetailsForInsured(policyList);
        if(!policyList?.length) {
            setOpen(true);
        }
      } else {
        setPoliciesDetailsForInsured([]);
      }
    } catch (e) {
      notify("error", "fetch failed!");
      appInsights.trackDependencyData({
              target: process.env.BASE_URL,
              name: "Word_searchByCriteria_Payload",
              dependencyTypeName: "HTTPS",
              success: false,
              responseCode: e?.status || 500,
              properties: {
                bodyData: {
                  compId: taskPaneState?.compId,
                  comLocId: taskPaneState?.comLocId,
                  criteria: taskPaneState?.criteria,
                  searchText: taskPaneState?.searchText,
                  userId: taskPaneState.userId
                },
                error: e,
                userId: taskPaneState.userId
              }
            });
      console.log(e);
    }
  };
  const handleGetRecent = async () => {
    try {
      clearToaster();
      // const result = await services.getRecentInsured(taskPaneState?.compId, taskPaneState.userId);
      // notify("success", "fetch successful!");
      // setTaskPaneState((prev) => ({
      //   ...prev,
      //   insuredForRecentPoliciesResults: result,
      // }));
        setPoliciesDetailsForInsured([]);
        setSelectedGridItem([]);
        setTaskPaneState((prev) => ({ ...prev, searchText: "" }));
        getLocationSpecificInfo(taskPaneState.compLocId, taskPaneState.compId);
    } catch (e) {
      // notify("error", "fetch failed!");
      console.log(e);
    }
  };
  return (
<>
      {Toaster}
       {open && 
       <AlertPopup 
       title="Search Failed" 
       text="Your search request returned no records. Please re-type your search text and try again." 
       open={open} 
       handleClose = {()=> setOpen(false)}/>}

          <div className="gap-2 grid" style={{ gridTemplateColumns: "minmax(0, 1fr) auto", alignItems: "center" }}>
           <div className="items-center gap-2 w-full flex flex-row seltest" style={{ minWidth: 0 }}>
                           <label style={{ flexShrink: 0 }} className="h3-text  text-left block text-gray-600 text-xs sm:text-sm lg:text-base font-medium mb-1 w-[4rem]">Location</label>
                            <Dropdown
                              aria-label="Location"
                              size="small"
                              positioning={{ autoSize: false }}
                              listbox={{ style: { maxHeight: "min(18rem, 60vh)", overflowY: "auto" } }}
                              style={{ minWidth: 0, width: "100%", height: "auto", flex: 1 }}
                              button={{ style: { whiteSpace: "normal", overflowWrap: "anywhere", textAlign: "left" } }}
                              value={locationData?.find((item) => String(item.compLocID) === String(taskPaneState.comLocId))?.companyLocation || "Select Location"}
                              selectedOptions={[String(taskPaneState.comLocId ?? "")]}
                              onOptionSelect={(_, data) => updateState("comLocId", data.optionValue)}
                              disabled={!locationData?.length}
                              className="decorated input-layout rounded py-0 px-0 text-xs sm:text-sm lg:text-base text-gray-700 w-full"
                          >
                             {locationData?.length !== 1 && <Option key={"none"} value={""}>
                                  {"Select Location"}
                              </Option>}
                              
                              {locationData.map((l) => {
                                  return (
                                      
                                        <Option key={l.compLocID} value={String(l.compLocID)}>
                                          {l.companyLocation}
                                        </Option>
                                      
                                  );
                              })}
                          </Dropdown>
                      </div>
                      <div>{appVersion}</div>
                  </div>
          <h2 className="h2-text text-left text-base font-semibold text-black-700 mb-1">
        Insured / Policy Information
      </h2>
      <h2 className="h3-text text-left text-base font-semibold text-gray-700 mb-1">Search Criteria</h2>
          {/* <div className="container"> */}
        <div className="gap-2 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3">
          {/* <div className="w-auto"> */}
          {/* </div> */}
          {/* <div className="w-auto mb-0"> */}
                      <Field className="items-center gap-2 w-full flex flex-column">
                          <Dropdown
                            aria-label="Search Criteria"
                            size="small"
                            positioning={{ autoSize: false }}
                            listbox={{ style: { maxHeight: "min(18rem, 60vh)", overflowY: "auto" } }}
                            style={{ minWidth: 0, width: "100%" }}
                            value={taskPaneState.criteria || ""}
                            selectedOptions={[String(taskPaneState.criteria ?? "")]}
                            onOptionSelect={(_, data) => updateState("criteria", data.optionValue)}
                              disabled={!taskPaneState?.criteriaItems?.length}
                                                            className="input-layout rounded py-0 px-0 text-xs sm:text-sm lg:text-base text-gray-700 w-full"
              >
                {taskPaneState?.criteriaItems?.map((criteria) => (
                  <Option key={criteria.criteriaName} value={criteria.criteriaName}>
                    {criteria.criteriaName}
                  </Option>
                ))}
              </Dropdown>
            </Field>
          {/* </div> */}
          {/* <div className="w-auto mt-0"> */}
            <Field className="items-center gap-2 w-full flex flex-column">
           <input
              value={taskPaneState.searchText}
              onChange={(e) => updateState("searchText", e.target.value)}
              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    if (taskPaneState?.searchText && !!taskPaneState?.searchText?.trim())
                                        handleSearch();
                                }
                            }}
              placeholder="Enter search term"
              className="input-layout rounded py-1 px-2 text-xs sm:text-sm lg:text-base text-gray-700 w-full"
            ></input>
          </Field>
        {/* </div> */}
                <div className="gap-2 w-full flex flex-row items-end justify-flex-start">
          <Button
            
            onClick={handleSearch}
                      className={`${(!taskPaneState?.searchText || taskPaneState?.searchText?.trim() == "" || !taskPaneState?.comLocId)? "btn-com-disable": "btn-com"}`}
                      appearance="primary"
                      disabled={!taskPaneState?.searchText || taskPaneState?.searchText?.trim() == "" || !taskPaneState?.comLocId}
          >
            Search
          </Button>
          { (
            <Button
              onClick={handleGetRecent}
               appearance="primary"
              className={`${(!taskPaneState?.compId || filterTypeByCriteriaType !== "Type Insured/Policy")? "btn-com-disable": "btn-com"}`}
              disabled={!taskPaneState?.compId || filterTypeByCriteriaType !== "Type Insured/Policy"}
              
            >
              Get Recent
            </Button>
          )}
        </div>
        </div>
       {/* </div> */}
        {/* <div className="mb-2 grid grid-cols-1 gap-4 sm:grid-cols-1 sm:gap-4 md:grid-cols-2 md:gap-3 lg:gap-2 xl:grid-cols-3 ">
      </div> */}
    </>
  );
};

export default SearchCriteria;
